import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './Cell.module.scss';

const Cell = ({
  children,
  className,
  height = '64',
  classNameContent,
  isId,
  ...other
}) => {
  return (
    <td className={cn(classes.base, className)} {...other} height={height}>
      <div
        className={cn(classes.content, classNameContent, isId && classes.isId)}
        {...other}
      >
        {children}
      </div>
    </td>
  );
};

Cell.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  height: PropTypes.string,
  classNameContent: PropTypes.string,
  isId: PropTypes.bool
};

export default Cell;
